import React from 'react';
import { useParams, RouteComponentProps } from '@reach/router';
import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/react-hooks';
import { AccountInformationPage } from '.';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';
import useFeatureFlag from '../../util/hooks/useFeatureFlag';
import { useGlobalContext } from '../../util/globalContextProvider';

const get_system_code = loader(
  './graphql/Account_Info_Page_Get_Account_System_Code.graphql'
);

export default (_: RouteComponentProps) => {
  const { accountNumber } = useParams();
  const { readOnlyAccess, readOnlyFeatureFlag } = useGlobalContext();

  const { flagDetails: billingCenterOutageFlagDetails } = useFeatureFlag(
    'BillingCenter-Outage'
  );
  const { flagDetails: policyCenterOutageFlagDetails } = useFeatureFlag(
    'PolicyCenter-Outage'
  );

  const variables = {
    account_number: accountNumber
  };

  const queryResult = useQuery(get_system_code, {
    variables
  });

  const { loading, error } = queryResult;

  const { data } = queryResult;

  let systemCode = null;

  if (data?.account.items && data.account.items[0]?.source_system_code) {
    systemCode = data.account.items[0]?.source_system_code.toLowerCase();
  }

  const props = {
    accountNumber,
    systemCode,
    billingCenterOutage: billingCenterOutageFlagDetails?.enabled,
    policyCenterOutage: policyCenterOutageFlagDetails?.enabled,
    readOnlyAccess,
    readOnlyFeatureFlag
  };

  return <AccountInformationPage {...props} />;
};